import { EModeCategoryId } from '@/domain/e-mode/types'
import { Info } from '@/ui/molecules/info/Info'
import { Switch } from '@/ui/atoms/switch/Switch'
import { EModeBadge } from '@/ui/molecules/e-mode-badge/EModeBadge'
import { useAccount } from '@/domain/hooks/useAccount'
import { usePrivy } from '@privy-io/react-auth'

interface EModeIndicatorProps {
  eModeCategoryId: EModeCategoryId
  onButtonClick: () => void
  hideInfo?: boolean
}

export function EModeIndicator({ eModeCategoryId, onButtonClick, hideInfo }: EModeIndicatorProps) {
  const account = useAccount()
  const { connectWallet } = usePrivy()

  return (
    <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
      {!hideInfo && (
        <div className="flex flex-row items-center gap-0.5">
          <p className="text-muted-foreground text-xs">E-Mode</p>
          <Info>Efficiency mode (E-Mode) increases your LTV for a selected category of assets up to 97%.</Info>
        </div>
      )}
      <Switch checked={eModeCategoryId !== 0} onClick={account ? onButtonClick : connectWallet} aria-label="E-Mode" />

      <EModeBadge categoryId={eModeCategoryId} />
    </div>
  )
}
